import React from 'react';

import GenericHeader from '../../containers/GenericHeaderContainer';
import BulkAdditionStepper from './bulkAdditionStepper';
import BottomActions from '../bottomActions';
import VendorsPreview from './vendorsPreview';
import history from '../../utils/history';
import SubmitBulkVendors from './submitBulkVendors';
import SuccessSVG from '../../assets/images/success.svg';

import Grid from '@techsoftware/happay-widgets/Grid';
import Button from '@techsoftware/happay-widgets/Button';
import Icons from '@techsoftware/happay-widgets/FontIcon';
import FileUpload from '@techsoftware/happay-widgets/FileUpload';

import { read, utils } from 'xlsx';
export default class BulkVendorAddition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stepNo: 1,
      stepStatus: '',
      file: {
        oldFiles: [],
        newFiles: [],
        deletedFiles: [],
      },
      showCancelConfirmation: false,
      bulkXlData: [],
      dataFetched: false,
      errorRes: {},
    };
  }

  componentWillUnmount() {
    this.props.setErrorData();
  }
  componentDidUpdate(prevProps) {
    const { submitStatus = '', errorData, setBulkSubmitStatus } = this.props;
    const { stepNo, bulkXlData, stepStatus } = this.state;
    if (
      errorData &&
      JSON.stringify(prevProps.errorData) !== JSON.stringify(errorData)
    ) {
      this.setState({
        stepNo: errorData?.show_preview ? 2 : 3,
        // errorRes: errorData,
      });
    }

    // else if (stepNo === 3 && stepStatus.length>0 && prevProps?.submitStatus !== submitStatus) {
    //   console.log("submitStatus,prevProps?.submitStatus",submitStatus,prevProps?.submitStatus)
    //   this.setState({ stepStatus: submitStatus });
    // }
  }

  handleScroll = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  };

  handleCancel = () => {
    const { stepNo } = this.state;
    if (stepNo === 1) {
      history.goBack();
    } else {
      this.setState({ stepNo: this.state.stepNo - 1 });
      this.props.setErrorData();
    }
  };
  returnStepper = () => {
    const { stepNo, stepStatus } = this.state;
    return <BulkAdditionStepper stepNo={stepNo} stepStatus={stepStatus} />;
  };
  initStates = () => {
    this.setState({
      stepNo: 1,
      stepStatus: '',
      file: {
        oldFiles: [],
        newFiles: [],
        deletedFiles: [],
      },
      showCancelConfirmation: false,
      bulkXlData: [],
      dataFetched: false,
    });
  };
  onUploadFile(files, msg, event) {
    // event.stopPropagation();
    // var files = event.target.files;
    let es = document.forms[0].elements;
    // let es = document.getElementById('my-file');
    let self = this;
    var i, f;
    for (i = 0, f = files[i]; i != files.length; ++i) {
      var reader = new FileReader();
      var name = f.name;
      let ext = name.split('.')[name.split('.').length - 1];

      if (ext != 'xls' && ext != 'xlsx') {
        this.props.openSnackbar({
          message: 'Upload excel file',
          type: 'error',
        });
        return false;
      }
      reader.onload = function(event) {
        let data = event.target.result;
        let workbook = read(data, { type: 'binary', cellDates: true });

        /* DO SOMETHING WITH workbook HERE */
        let sheet_name_list = workbook.SheetNames;
        let XLSheetsData = [];
        let blankSheets = 0;

        try {
          sheet_name_list.forEach(function(y, i) {
            /*---Construct Headers for each Table---*/
            if (y != 'Hidden') {
              let headerArr = utils.sheet_to_json(
                workbook.Sheets[workbook.SheetNames[i]],
                { header: 1 },
              )[0];
              headerArr.unshift('S.No');
              let header_obj = {};
              headerArr.forEach(el => {
                header_obj[el] = '';
              });
              let xlData = [];
              //Access inner data of XLSX file
              let innerData = utils.sheet_to_json(workbook.Sheets[y]);
              xlData = innerData.map((el, j) => {
                return Object.assign({}, header_obj, el, { 'S.No': j + 1 });
              });
              if (xlData.length == 0) blankSheets++;

              XLSheetsData.push({
                data: xlData,
                headers: headerArr,
                sheetName: y,
              });
            }
          });
          if (XLSheetsData.length == blankSheets) {
            if (es[0].value) {
              try {
                es[0].value = '';
              } catch (err) {}
              if (es[0].value) {
                var form = document.createElement('form'),
                  ref = es[0].nextSibling;
                form.appendChild(es[0]);
                form.reset();
                ref.parentNode.insertBefore(es[0], ref);
              }
            }
            self.props.openSnackbar({
              message: 'Blank file uploaded',
              type: 'error',
            });
            return false;
          }
          if (XLSheetsData[0].data.length > 500) {
            self.props.openSnackbar({
              message:
                'The maximum rows accepted per file is 500. Please check the file and re-upload.',
              type: 'error',
            });
            return false;
          }
          const { file } = self.state;
          file.newFiles = files;
          self.setState({
            file,
            bulkXlData: XLSheetsData,
          });
        } catch (e) {
          console.log('error', e);
          // self.setState({
          //   actionType: type,
          //   xlFile: files[0],
          //   //showXlTable: true,
          //   onlySubmitButton: true,
          //   uploadFileName: [0].name,
          //   upload: true,
          //   //isDataFetched: true,
          // });
        }
      };
      reader.readAsBinaryString(f);
    }
  }
  onDeleteFile = (index, type) => {
    const { file } = this.state;
    if (type === 'newFiles') {
      file.newFiles.splice(index, 1);
    } else if (type === 'oldFiles') {
      file.oldFiles.splice(index, 1);
    }
    this.setState({
      file,
    });
  };
  handlePreview = val => {
    this.setState({ stepNo: 2, dataFetched: true });
    this.handleScroll();
    // history.push('/vendor/myvendor/bulkcreateview/preview');
  };
  returnStep2UI = () => {
    const { bulkXlData, file, stepStatus, errorRes } = this.state;
    const { downloadTemplate, errorData = {} } = this.props;

    return (
      <VendorsPreview
        bulkXlData={bulkXlData}
        handleDownloadTemplate={this.handleDownloadTemplate}
        handleCancel={() => this.handleCancel()}
        errorRes={errorData}
      />
    );
  };
  returnStep3UI = () => {
    const { stepStatus } = this.state;
    const { submitStatus } = this.props;
    return submitStatus ? (
      <SubmitBulkVendors
        stepStatus={submitStatus}
        initStates={this.initStates}
      />
    ) : (
      false
    );
  };
  handleDownloadTemplate = type => {
    const { downloadTemplate, submitStatus = '' } = this.props;
    const { file } = this.state;
    if (type === 'Download') {
      downloadTemplate();
    } else if (type === 'Submit') {
      const finalObj = new FormData();
      finalObj.append('file', file.newFiles[0]);
      downloadTemplate(finalObj, type);
      this.setState({ stepNo: 3 });
    }
  };
  returnStepperContent = () => {
    const { stepNo, file, showCancelConfirmation, bulkXlData } = this.state;
    const { newFiles = [] } = file || {};
    if (stepNo === 1) {
      return (
        <Grid item container xs={24} sm={24} md={24} lg={24} xl={24}>
          <Grid
            container
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            className={`white-bg primary-dark-color`}
          >
            <Grid
              item
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              className="padding-b-20 white-bg fw-600 font-16 dark-blue-grey font-family-cncl fw-500"
            >
              <Grid
                item
                className={
                  ' padding-lr-30 padding-b-20 border-bottom font-14 fw-600'
                }
              >
                Upload File
                <Grid
                  item
                  className={'padding-t-10  font-13 fw-400 light-black'}
                >
                  You can download the template, update your vendor details and
                  upload it below so we can create vendors for you.
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              className="padding-lr-30 padding-t-10 padding-b-20 white-bg fw-500 font-14 dark-blue-grey flex-d-column d-flex align-item-baseline-imp stepper-upload-file"
            >
              Don't have a template? Click below to download the file (.xlsx)
              and update your information in it.
              <Button
                type="button"
                text={
                  <>
                    <Icons type="download" className={'padding-r-8'} />
                    Download Template
                  </>
                }
                variant="primary"
                size="medium"
                onClick={() => this.handleDownloadTemplate('Download')}
                className={'margin-t-16 margin-b-36 flex-vertical-center'}
              />
              Getting started with the upload? Please read the instructions
              below before uploading the file:
              <Grid item className="width-100 margin-t-16">
                {!newFiles.length ? (
                  <form>
                    <FileUpload
                      id="my-file"
                      attachmentDivId="my-file-container"
                      popupStyle={{ padding: 10 }}
                      files={file}
                      uploadFiles={(f, msg, event) =>
                        this.onUploadFile(f, msg, event)
                      }
                      deleteFiles={(index, type) =>
                        this.onDeleteFile(index, type)
                      }
                      acceptedFiles={['.xlsx', '.xls']}
                      labelText={
                        <div className="d-flex flex-direction-column flex-vertical-center">
                          <div className="fw-600 d-flex">
                            <Icons
                              type="addinsurance"
                              size="small"
                              className="padding-r-6"
                            />{' '}
                            Drag & Drop or
                          </div>
                          <div className="padding-lr-20 padding-tb-10 border-radius-4 purple-border margin-t-12">
                            Upload Excel File
                          </div>
                        </div>
                      }
                      iconType=""
                      multiple={false}
                      enableLightBox
                      maxAttachment={1}
                      variant="tertiary"
                      // inPlaceAttachment
                      inplaceUploadWrapper={{ height: '200px' }}
                      attachementStyle={{ maxHeight: '200px' }}
                      fileWrapperStyle={{
                        marginBottom: '20px',
                      }}
                    />
                  </form>
                ) : (
                  <div
                    style={{ height: '170px' }}
                    className="primary-border-dashed border-radius-4 margin-b-20 flex-center flex-direction-column"
                  >
                    <img
                      src={SuccessSVG}
                      alt="success"
                      className="height-60 width-60"
                    />
                    <div className="font-12 body margin-b-6 margin-t-16">
                      {newFiles[0].name}
                    </div>
                    <Button
                      type="button"
                      text="Change File"
                      variant="tertiary"
                      size="medium"
                      onClick={() => this.onDeleteFile(0, 'newFiles')}
                    />
                  </div>
                )}
                <Grid item className="font-12 dark-text">
                  <Grid item> INSTRUCTIONS: </Grid>
                  <Grid item className=" fw-400">
                    <div>1. Only Excel file type is accepted.* </div>
                    <div>2. The maximum rows accepted per file is 500.* </div>
                    <div>
                      3. You are not allowed to tamper with the column headers.*
                    </div>
                  </Grid>
                </Grid>
                <BottomActions
                  handleActionClick={val => this.handlePreview(val)}
                  from="Bulk Vendors"
                  // validation={true}
                  disabled={bulkXlData.length === 0}
                  actionMap={{ Preview: 'Preview' }}
                  showCancelConfirmation={true}
                  handleCancel={() => this.handleCancel()}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    } else if (stepNo === 2) {
      return this.returnStep2UI();
    } else if (stepNo === 3) {
      return this.returnStep3UI();
    }
  };
  render() {
    return (
      <Grid container justify={'center'}>
        <Grid item>
          <GenericHeader
            title={'Bulk Vendor Addition'}
            showBreadcrumbs={false}
            from="vendor"
          />
        </Grid>
        <Grid
          item
          className="border-container-imp white-bg border-radius-4 margin-b-20 margin-t-100"
          xs={22}
          sm={18}
          md={16}
          xl={16}
          lg={16}
        >
          <Grid item className="payment-card-title border-b">
            <div className="d-flex padding-lr-30 padding-tb-20">
              {this.returnStepper()}
            </div>
          </Grid>
        </Grid>
        <Grid
          item
          className="border-container-imp white-bg border-radius-4 margin-b-20 margin-t-20 margin-b-100"
          xs={22}
          sm={18}
          md={16}
          xl={16}
          lg={16}
        >
          <Grid item className="payment-card-title border-b">
            <div className="d-flex  padding-t-20">
              {this.returnStepperContent()}
            </div>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
